import { gql } from 'graphql-request';

export const COLLECTION_PRODUCT_FIELDS = gql`
    fragment CollectionProductFields on Product {
        id
        title
        handle
        productType
        tags
        gender: metafield(namespace: "custom", key: "gender_multiselect") {
            value
        }
        customProductType: metafield(namespace: "custom", key: "product_type") {
            value
        }
        capsule: metafield(namespace: "custom", key: "capsule") {
            value
        }
        collections(first: 25) {
            edges {
                node {
                    handle
                    title
                }
            }
        }
        parentSKU: metafield(namespace: "custom", key: "parent_sku") {
            value
        }
        isNewArrival: metafield(namespace: "custom", key: "is_new_arrival") {
            value
        }
        notifyMeForm: metafield(namespace: "custom", key: "notify_me_form") {
            value
        }
        availableForSale
        images(first: 25) {
            edges {
                node {
                    altText
                    height
                    transformedSrc
                }
            }
        }
        media(first: 25) {
            edges {
                node {
                    ... on Video {
                        id
                        previewImage {
                            altText
                            transformedSrc
                            width
                            height
                        }
                        sources {
                            mimeType
                            url
                        }
                    }
                }
            }
        }
        variants(first: 50) {
            edges {
                node {
                    id
                    sku
                    title
                    availableForSale
                    quantityAvailable
                    image {
                        transformedSrc
                    }
                    priceV2 {
                        amount
                        currencyCode
                    }
                    compareAtPriceV2 {
                        amount
                    }
                    selectedOptions {
                        name
                        value
                    }
                }
            }
        }
        videoURL: metafield(
            namespace: "custom"
            key: "pdp_media_gallery_video"
        ) {
            value
        }
        galleryVideosSynced: metafield(
            namespace: "custom"
            key: "product_gallery_videos_synced"
        ) {
            value
        }
        discountBucket: metafield(namespace: "custom", key: "discount_bucket") {
            value
        }
    }
`;
